import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { Subject } from 'rxjs';
import { AppComponent } from '../app.component';
import { ApiService } from '../services/api.service';
import { PermissionsService } from '../services/permissions.service';
import { Router } from '@angular/router';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-dharmshala-booking-list',
  templateUrl: './dharmshala-booking-list.component.html',
  styleUrls: ['./dharmshala-booking-list.component.scss']
})
export class DharmshalaBookingListComponent implements OnInit {

  public payment_report: any;
  allDharmshalaBooking: any;
  public from_date = moment(new Date()).format('YYYY-MM-DD');
  public to_date = moment(new Date()).format('YYYY-MM-DD');
  public payment_status = 'Pending';
  public onChangeSearch = new Subject<string>();
  public perPage = 20;
  public totalCount = 0;
  public page = 1;
  public maxDate = ''; // moment(new Date()).format('YYYY-MM-DD');
  public dharmshala_id = '';
  public room_type_id = '';
  public allDharmshala: any[] = [];
  public allRoomTypes: any[] = [];
  public expandedBookingId: number | null = null;

  constructor(
    private apiService: ApiService,
    private appComponent: AppComponent,
    private router: Router,
    public permissionsService: PermissionsService

    ) { }

  ngOnInit() {
    this.getList('');
    this.getAllDharmshala();
  }

  getList(_type) {
    this.appComponent.showLoader();
    const from_date = moment(this.from_date).format('YYYY-MM-DD');
    const to_date = moment(this.to_date).format('YYYY-MM-DD');
    this.apiService.getDataFromServer(`/dharmshala_booking?dharmshala_id=${this.dharmshala_id}&room_type_id=${this.room_type_id}&from_date=${from_date}&to_date=${to_date}&booking_start_date=&page=${this.page}&perpage=${this.perPage}`).subscribe(
      (res: any) => { 
        this.appComponent.hideLoader();
        this.allDharmshalaBooking = res;
        this.allDharmshalaBooking.data.map(res => {
          // res.created_at = moment.utc(res.created_at).local().format('DD-MM-YYYY h:mm a z');
          res.from_date = moment.utc(res.from_date).local().format('DD-MM-YYYY');
          res.to_date = moment.utc(res.to_date).local().format('DD-MM-YYYY');
        });
        this.totalCount = res.total;
      },
      err => {
        console.log(err);
      }
    );
  }

  navigateTo(url) {
    this.router.navigate([url]);
  }

  getAllDharmshala() {
    this.apiService.getDataFromServer('/dharmashalas').subscribe(
      (res: any) => {
        this.allDharmshala = res.data || [];
      },
      err => {
        console.log(err);
      }
    );
  }

  onDharmshalaChange() {
    this.room_type_id = ''; // Reset room type selection
    this.allRoomTypes = []; // Clear room types
    
    if (this.dharmshala_id) {
      const selectedDharmshala = this.allDharmshala.find(d => d.id == this.dharmshala_id);
      if (selectedDharmshala && selectedDharmshala.dharmashala_details) {
        this.allRoomTypes = selectedDharmshala.dharmashala_details.map(detail => ({
          id: detail.room_type.id,
          name: detail.room_type.title
        }));
      }
    }
  }

  toggleBookingRooms(bookingId: number) {
    if (this.expandedBookingId === bookingId) {
      this.expandedBookingId = null;
    } else {
      this.expandedBookingId = bookingId;
    }
  }

  exportData() {
    this.appComponent.showLoader();
    const from_date = moment(this.from_date).format('YYYY-MM-DD');
    const to_date = moment(this.to_date).format('YYYY-MM-DD');
    
    this.apiService.getDataFromServer(`/dharmshala_booking/export?dharmshala_id=${this.dharmshala_id}&room_type_id=${this.room_type_id}&from_date=${from_date}&to_date=${to_date}&booking_start_date=&page=${this.page}&perpage=${this.perPage}`).subscribe((res: any) => {
      if(res.status_code === 200) {
        const fileArry = res.data.split('/uploads/');
        this.apiService.getBlobFileFromServer(res.data).subscribe(res => {
          this.appComponent.hideLoader();
          let blob:any = new Blob([res], { type: res.type });
          const url = window.URL.createObjectURL(blob);
          let file_name = fileArry[fileArry.length - 1];
          saveAs(blob, file_name);
        }, (error) => {
          this.appComponent.hideLoader();
        });
      }
      this.appComponent.hideLoader();
    }, (error) => {
      this.appComponent.hideLoader();
      console.log('error' , error);
    });
  }

}